export const nonUserFacingTags = ['line chart', 'multi-line', 'chart', 'stacked area', 'area chart', 'light', 'dark'];